<template>
  <div class="manage-filter__create">
    <button class="button button--secondary-fill manage-filter__create-button" @click="modalShow = !modalShow">New Domain List</button>
    <b-modal v-model="modalShow">
      <b-input type="text" v-model="domainlist.name" />
      <b-form-file v-model="domainlist.domains" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
      <div class="mt-3">Selected file: {{file}}</div>

    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'newDomain',
  data () {
    return {
      modalShow: false,
      file: null,
      domainlist: {
        name: null,
        domains: 'null'
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/advertiser/campaign/manager/newdomain.vue